
export type loop_type = {
    old: number;
    now: number;
    delta_ms: number;   //ms since last frame, clamped to 33 (Body/Pnts/etc. step by delta_ms * 0.05)
    delta_s: number;    //seconds since last frame, clamped to 0.05, 1/60 on the first frame — physics step delta
    scale: number;      //delta_s normalized to a 60fps frame: 1 at 60fps, 2 at 30fps. Multiply per-frame `x += speed` motion by this for frame-rate independence.
}

export type Loopable = {
    run: (time: loop_type) => void;
    [key: string]: any; // Allows any additional properties
}

export function make_loop() {

    const time = {
        old: 0,
        now: 0,
        delta_ms: 0,
        delta_s: 1 / 60,
        scale: 1
    };

    const obj = {

        run: function (objects: Loopable[]): void {

            time.old = time.now;
            time.now = performance.now();
            time.delta_ms = Math.min(time.now - time.old, 33);
            //seconds delta: clamped to 0.05, 1/60 before the first real interval. The physics step + the basis for scale,
            //so motion is frame-rate-independent (correct at iOS Low-Power 30fps too).
            time.delta_s = time.old === 0 ? 1 / 60 : Math.min((time.now - time.old) / 1000, 0.05);
            time.scale = time.delta_s * 60;   //60fps-normalized multiplier for per-frame motion.

            for (const o of objects) {
                o.run(time);
            }

            requestAnimationFrame(() => this.run(objects));
        }
    }

    return obj
}